import { render, staticRenderFns } from "./policyStatusSelect.vue?vue&type=template&id=12c50fd4&"
import script from "./policyStatusSelect.vue?vue&type=script&lang=js&"
export * from "./policyStatusSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports